type TeamType =
  | "compre meu carro"
  | "venda direta"
  | "vende meu carro"
  | "serviços"
  | "cms"
  | "veiculos-novos"
  | "home"
  | "consorcio"
  | "Veiculos Novos";

interface FormData {
  name: string;
  cpf: string;
  email: string;
  phone: string;
  dealer?: string;
  model?: string;
  service?: string;
  page?: string;
  contactMethod?: string;
  plate?: string;
  mileage?: string;
  expectedValue?: string;
}

interface SubmitParams {
  params: string;
  consorcio: boolean;
  registrationNumber: string;
  team: TeamType;
  locationId: number;
  model: string | number;
  page: string;
  wpp: boolean;
}

export function determineTeamBasedOnPage(page: string): string {
  const pageLower = page?.toLowerCase() || "";
  if (pageLower.includes("venda-direta")) return "Venda Direta";
  if (pageLower.includes("serviços - pós-venda")) return "Serviços - Pós-Venda";
  if (pageLower.includes("consorcio")) return "Consórcio";
  if (pageLower.includes("pessoa-com-deficiencia")) return "Venda Direta - PCD";
  if (pageLower.includes("frotista")) return "Venda Direta - Frotista";
  if (pageLower.includes("governo")) return "Venda Direta - Governo";
  if (pageLower.includes("taxista")) return "Venda Direta - Taxista";
  if (pageLower.includes("produtor-rural"))
    return "Venda Direta - Produtor Rural";
  if (
    [
      "corolla-cross",
      "corolla-hatch",
      "corolla",
      "hilux",
      "rav4",
      "sw4",
      "yaris",
    ].some((car) => pageLower.includes(car))
  ) {
    return "Veículos Novos";
  }
  if (pageLower.includes("servicos")) return "Serviços";
  if (pageLower.includes("cms")) return "cms";
  if (pageLower.includes("[carro]")) return "veiculos-novos";
  if (pageLower.includes("app")) return "home";
  if (pageLower.includes("não informado")) return "não informado";

  return "Não Informado";
}

const handleSubmit = async (
  event: React.FormEvent<HTMLFormElement>,
  submitParams: SubmitParams
) => {
  event.preventDefault();

  const form = event.currentTarget;
  const submitButton = form.querySelector(
    'button[type="submit"]'
  ) as HTMLButtonElement;

  if (submitButton) {
    submitButton.disabled = true;
    submitButton.style.opacity = "0.7";
    submitButton.style.cursor = "not-allowed";
  }

  const brand = "toyota";

  const getFieldValue = (fieldId: string): string => {
    const element = form.querySelector<HTMLInputElement | HTMLSelectElement>(
      `#${fieldId}`
    );
    return element?.value.trim() ?? "";
  };

  const getContactMethods = (): string => {
    const checkboxes = form.querySelectorAll<HTMLInputElement>(
      'input[name="contactMethod"]:checked'
    );
    return Array.from(checkboxes)
      .map((input) => input.value)
      .join(", ");
  };

  const currentPageTeam = determineTeamBasedOnPage(submitParams.page);

  const formData: FormData = {
    name: getFieldValue("nameInput"),
    cpf: getFieldValue("cpfInput").replace(/\D/g, ""),
    email: getFieldValue("emailInput"),
    phone: getFieldValue("phoneInput").replace(/\D/g, ""),
    dealer: getFieldValue("dealerInput"),
    model: getFieldValue("modelInput"),
    service: getFieldValue("serviceInput"),
    contactMethod: getContactMethods(),
    plate: getFieldValue("plateInput")?.toUpperCase(),
    mileage: getFieldValue("mileageInput"),
    expectedValue: getFieldValue("expectedValueInput"),
    page: submitParams.page,
  };

  try {
    const response = await fetch("/api/submitForm", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ...formData,
        ...submitParams,
        model: formData.model,
        team: currentPageTeam,
        brand,
      }),
    });

    if (!response.ok) {
      throw new Error("Erro ao enviar os dados para a API.");
    }

    // Criar e adicionar o popup de sucesso
    const popup = document.createElement("div");
    popup.classList.add("popup-container");

    popup.innerHTML = `
       <div style="
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: white;
          padding: 20px;
          border-radius: 10px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          text-align: center;
          z-index: 9999;
          width: 90%;
          max-width: 400px;
          min-height: 450px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
        ">
          <div style="
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 20px;
            flex: 1;
          ">
            <img 
              src="https://sablobsitestoyotaprd.blob.core.windows.net/images/email_enviado.svg" 
              alt="Email enviado"
              style="
                width: 100%;
                max-width: 200px;
                height: auto;
                object-fit: contain;
              "
            />
          </div>
          <h3 style="
            margin: 20px 0; 
            color: #333; 
            font-size: 24px;
            font-weight: 400;
          ">Seus dados foram enviados com sucesso!</h3>
          <p style="
            color: #666; 
            margin-bottom: 30px;
            font-size: 14px;
          ">Em breve um de nossos consultores entrará em contato</p>
          <button onclick="this.closest('.popup-container').remove()" style="
            background: #dc2626;
            color: white;
            border: none;
            padding: 12px 0;
            width: 100%;
            border-radius: 5px;
            cursor: pointer;
            font-weight: 400;
            font-size: 16px;
            transition: opacity 0.2s;
          ">Fechar</button>
        </div>
        <div style="
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          z-index: 9998;
        "></div>`;

    document.body.appendChild(popup);

    // Reset do formulário
    form.reset();

    // Reabilitar o botão de submit
    if (submitButton) {
      submitButton.disabled = false;
      submitButton.style.opacity = "1";
      submitButton.style.cursor = "pointer";
    }

    return true;
  } catch (error) {
    console.error("Erro ao enviar formulário:", error);
    alert("Erro ao enviar formulário. Por favor, tente novamente.");

    if (submitButton) {
      submitButton.disabled = false;
      submitButton.style.opacity = "1";
      submitButton.style.cursor = "pointer";
    }

    return false;
  }
};

declare global {
  interface Window {
    handlePopupClose: (element: HTMLElement, isWhatsApp: boolean) => void;
  }
}

export default handleSubmit;
